import { inject } from '@angular/core';
import { CanActivateChildFn } from '@angular/router';
import { Store } from '@ngrx/store';
import { AppStore } from '@aaa/emember/store-types';
import { first, tap } from 'rxjs';
import { map } from 'rxjs/operators';
import { getAccountDetails } from '@aaa/emember/store-account';
import { MembershipRenewActions } from '@aaa/emember/store-membership-renew';

export const setMembershipRenewAccountDetails: CanActivateChildFn = () => {
  const store = inject(Store<AppStore>);

  return store.select(getAccountDetails).pipe(
    first((accountDetails) => !!accountDetails),
    tap((accountDetails) => {
      if (accountDetails) {
        store.dispatch(MembershipRenewActions.setAccountDetails({ accountDetails }));
      }
    }),
    map(() => true),
  );
};

export default setMembershipRenewAccountDetails;
